import { Buttons, MUIcon, Toggles } from '@platform/shared/ui';
import { ProjectTypes } from '@platform/types';
import React from 'react';

interface Props {
  workingLayer: ProjectTypes.AnyWorkingLayer;
  onChange: (data: ProjectTypes.WorkingLayerGeoMaskingSelection) => void;
}

const WorkingLayerGeoMasking: React.FC<Props> = ({ onChange, workingLayer }) => {
  const { maskingSelection } = workingLayer;

  const handleMaskChange = () => onChange({ ...maskingSelection, doMask: !workingLayer.maskingSelection.doMask });

  const handleFeatureRemoval = (fId: string | number) =>
    onChange({ ...maskingSelection, features: maskingSelection.features.filter((f) => f.id !== fId) });

  return (
    <div className="flex flex-col gap-2">
      {maskingSelection.features.length ? (
        <>
          <Toggles.Toggle
            label="Mask selection"
            checked={workingLayer.maskingSelection.doMask}
            onChange={handleMaskChange}
          />
          <div className="flex flex-wrap gap-2">
            {maskingSelection.features.map((f) => (
              <div className="flex items-center gap-1 rounded-md bg-gray-200 p-0.5 pl-2" key={f.id}>
                {f.name}
                <Buttons.Link
                  className="p-1"
                  icon={<MUIcon name="close" className="text-sm" />}
                  onClick={() => handleFeatureRemoval(f.id)}
                />
              </div>
            ))}
          </div>
        </>
      ) : (
        'Nothing selected'
      )}
    </div>
  );
};

export default WorkingLayerGeoMasking;
